import { formatSuccessRate } from "@/utils/success-rate";

interface SuccessRateCellProps {
  value: number | null;
}

const SuccessRateCell = ({ value }: SuccessRateCellProps) => {
  return <span className="text-gray-500">{formatSuccessRate(value)}</span>;
};

export default SuccessRateCell;
